
import { defineComponent } from "vue";

const svgContext = require.context(
	"!svg-inline-loader?" +
    "removeTags=true" +             // remove title tags, etc.
    "&removeSVGTagAttrs=true" +     // enable removing attributes
    "!@/assets/icons",              // search this directory
	true,                           // search subdirectories
	/\w+\.svg$/i                    // only include SVG files
);
const symbols = svgContext.keys().map((path) => {
	const content = svgContext(path);                   	// get SVG file content
    const id = path.replace(/^\.\/(.*)\.\w+$/, "$1");       // extract icon id from filename

	return content                                          // replace svg tags with symbol tags and id attribute
		.replace("<svg", `<symbol id="${id}"`)
		.replace("svg>", "symbol>");
});

export default defineComponent({
	name: "SvgSprite",
	setup() {
		return {
			svgSprite: symbols.join("\n"),
		};
	},
});
